import React, { useState, useEffect } from 'react'
import { reduxForm } from 'redux-form'
import { Col, Row, Card } from 'react-bootstrap'
import {
    Tabs,
    Tab
} from 'components/shared/Tabs'
import { profileTabs } from 'constants/constantVariables'
import ProfileDetailForm from './partial/profileDetail'
import PasswordField from './partial/passwordField'
import SignatureSettings from './partial/SignatureSettings'
import MonitoringAlertsSetting from './partial/MonitoringAlertsSetting'
import strings from 'strings'
import authService from "../../tools/AuthService";

const Profile = (props) => {
    const {
        handleSubmit,
        dispatchFormConfig, // action to set form config
        updateProfile,
        updatePassword,
        getUserDetailByToken,
        history
    } = props
    const [tabValue, setTabValue] = useState(0)
    // Credit memo approvers set up how they sign on their own profile.
    const showSignature = authService.getClientFeatures().creditMemoApprovalEnabled
        && authService.hasPrivilege('APPROVE_CREDIT_MEMO')
    // Monitoring alert pause (advanced monitoring clients only; not for read-only users or sales reps, who get no alerts).
    const { monitoringEnabled, monitoringAdvancedEnabled, isReadOnlyUser } = authService.getClientFeatures()
    const showNotifications = !!monitoringEnabled && !!monitoringAdvancedEnabled && !isReadOnlyUser && !authService.isSalesRep()
    const tabs = [
        ...profileTabs,
        ...(showSignature ? [{ label: strings.PROFILE_SIGNATURE.TAB }] : []),
        ...(showNotifications ? [{ label: strings.PROFILE_NOTIFICATIONS.TAB }] : []),
    ]
    const signatureIndex = showSignature ? 2 : -1
    const notificationsIndex = showNotifications ? (showSignature ? 3 : 2) : -1

    // The approve dialog links here with ?tab=signature; the monitoring drawer and the bell with ?tab=notifications.
    useEffect(() => {
        const tab = new URLSearchParams(window.location.search).get('tab')
        if (tab === 'signature' && signatureIndex >= 0) setTabValue(signatureIndex)
        if (tab === 'notifications' && notificationsIndex >= 0) setTabValue(notificationsIndex)
    }, [signatureIndex, notificationsIndex])

    useEffect(() => {
        dispatchFormConfig({
            type: strings.PROFILE_FORM
        })
    }, [dispatchFormConfig])

    const handleTabValue = (val) => {
        if (val === 0) {
            dispatchFormConfig({
                type: strings.PROFILE_FORM,
            })
        } else if (val === 1) {
            dispatchFormConfig({
                type: strings.PASSWORD_CHANGE_FORM,
            })
        }
        setTabValue(val)
    }

    const submitProfile = (data) => {
        updateProfile(data).then(() => {
            getUserDetailByToken()
            history.push(`/dashboard`)
        })
    }

    const submitPassword = (data) => {
        updatePassword(data).then(res => {
            authService.setToken(res.Authorization)
            authService.setRefreshToken(res.Refresh_token)
            return history.push(`/dashboard`);
        })
    }

    return (
        <div>
            <Row>
                <Col md={6} className="text-left">
                    <h4>{strings.PROFILE}</h4>
                </Col>
            </Row>
            <Tabs
                data={tabs}
                value={tabValue}
                onChange={(e, val) => handleTabValue(val)}
            />
            <Card className='p-4 cardHeight'>
                <Tab value={tabValue} index={0}>
                    <ProfileDetailForm
                        onSubmit={handleSubmit(submitProfile)}
                    />
                </Tab>
                <Tab value={tabValue} index={1}>
                    <PasswordField
                        onSubmit={handleSubmit(submitPassword)}
                    />
                </Tab>
                {showSignature && (
                    <Tab value={tabValue} index={signatureIndex}>
                        <SignatureSettings />
                    </Tab>
                )}
                {showNotifications && (
                    <Tab value={tabValue} index={notificationsIndex}>
                        <MonitoringAlertsSetting />
                    </Tab>
                )}
            </Card>
        </div>
    )
}

export default reduxForm({
    form: 'userProfileForm',
    enableReinitialize: true
})(Profile)